export const GET_GIFT_CARD_SETTINGS_STARTED = "GET_GIFT_CARD_SETTINGS_STARTED"
export const GET_GIFT_CARD_SETTINGS_SUCCESS = "GET_GIFT_CARD_SETTINGS_SUCCESS"
export const GET_GIFT_CARD_SETTINGS_FAILURE = "GET_GIFT_CARD_SETTINGS_FAILURE"

export const UPDATE_GIFT_CARD_SETTINGS_STARTED = "UPDATE_GIFT_CARD_SETTINGS_STARTED"
export const UPDATE_GIFT_CARD_SETTINGS_SUCCESS = "UPDATE_GIFT_CARD_SETTINGS_SUCCESS"
export const UPDATE_GIFT_CARD_SETTINGS_FAILURE = "UPDATE_GIFT_CARD_SETTINGS_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"